/* ADSCALAR — global theme behaviour: mobile nav, announcement rotation,
   footer accordion, wishlist badge count. Vanilla, no dependencies. */
(function () {
  // ── Mobile nav drawer ──
  var burger = document.querySelector('[data-asc-burger]');
  var mnav = document.querySelector('[data-asc-mnav]');
  var scrim = document.querySelector('[data-asc-mnav-scrim]');
  var close = document.querySelector('[data-asc-mnav-close]');
  function openNav() {
    if (!mnav) return;
    mnav.classList.add('open'); scrim.classList.add('open');
    mnav.setAttribute('aria-hidden', 'false');
    if (burger) burger.setAttribute('aria-expanded', 'true');
    document.body.classList.add('scroll-locked');
  }
  function closeNav() {
    if (!mnav) return;
    mnav.classList.remove('open'); scrim.classList.remove('open');
    mnav.setAttribute('aria-hidden', 'true');
    if (burger) burger.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('scroll-locked');
  }
  if (burger) burger.addEventListener('click', openNav);
  if (close) close.addEventListener('click', closeNav);
  if (scrim) scrim.addEventListener('click', closeNav);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeNav(); });

  // ── Announcement rotation (message count + speed both editable via
  //    Theme settings -> Announcement bar) ──
  var rot = document.querySelector('[data-asc-announce]');
  if (rot) {
    var msgs = rot.querySelectorAll('.msg');
    var rotateMs = parseInt(rot.getAttribute('data-rotate-ms'), 10) || 4200;
    if (msgs.length > 1) {
      var i = 0;
      setInterval(function () {
        var cur = msgs[i];
        cur.classList.remove('on'); cur.classList.add('out');
        i = (i + 1) % msgs.length;
        var nxt = msgs[i];
        nxt.classList.remove('out'); nxt.classList.add('on');
        setTimeout(function () { cur.classList.remove('out'); }, 500);
      }, rotateMs);
    }
  }

  // ── Footer accordions (mobile) ──
  document.querySelectorAll('[data-asc-facc]').forEach(function (acc) {
    var btn = acc.querySelector('button');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var open = acc.classList.toggle('open');
      var t = acc.querySelector('.toggle');
      if (t) t.textContent = open ? '−' : '+';
    });
  });

  // ── heart-pulse micro-interaction (mirrors Hydrogen useCountPulse) ──
  // Replay a short scale keyframe on a badge; CSS gates it behind
  // prefers-reduced-motion: no-preference so it stays motion-safe.
  function pulseBadge(el) {
    el.classList.remove('asc-pulse');
    // force reflow so the animation can replay on a rapid second add
    void el.offsetWidth;
    el.classList.add('asc-pulse');
  }

  // ── Wishlist badge count (localStorage shared with PDP/cards) ──
  // baseline starts null so the badge never pulses on initial hydration —
  // it only animates when a later change actually INCREASES the count.
  var wishBaseline = null;
  function refreshWish() {
    var n = 0;
    try { n = (JSON.parse(localStorage.getItem('ek_wishlist') || '[]') || []).length; } catch (e) {}
    var pulse = wishBaseline !== null && n > wishBaseline;
    wishBaseline = n;
    document.querySelectorAll('[data-asc-wishcount]').forEach(function (el) {
      el.textContent = n > 99 ? '99+' : n;
      el.hidden = n === 0;
      if (pulse) pulseBadge(el);
    });
  }
  refreshWish();
  window.addEventListener('storage', refreshWish);
  window.addEventListener('ek:wishlist-change', refreshWish);

  // ── Cart badge pulse on client-side add ──
  // Header cart count is server-rendered; when the cart drawer / ATC flow
  // dispatches 'ek:cart-change' with a {count} detail, pulse the badge on an
  // increase (same null-baseline rule so it stays quiet on first paint).
  var cartBaseline = null;
  (function () {
    var first = document.querySelector('[data-asc-cartcount]');
    if (first && !first.hidden) {
      var v = parseInt(first.textContent, 10);
      if (!isNaN(v)) cartBaseline = v;
    }
  })();
  window.addEventListener('ek:cart-change', function (e) {
    var n = e && e.detail && typeof e.detail.count === 'number' ? e.detail.count : null;
    if (n === null) return;
    var pulse = cartBaseline !== null && n > cartBaseline;
    cartBaseline = n;
    document.querySelectorAll('[data-asc-cartcount]').forEach(function (el) {
      el.textContent = n > 99 ? '99+' : n;
      el.hidden = n === 0;
      if (pulse) pulseBadge(el);
    });
  });
})();

/* Currency / country picker. Only present when the store actually has more
   than one market — see the note in sections/asc-header.liquid. Each option is
   a submit button on Shopify's own /localization form, so the switch works
   with JS disabled too; this only handles opening and closing the menu. */
(function () {
  // Class fallback as well as the data hook: the wrapper is emitted by Liquid's
  // {% form 'localization' %} tag, so don't let the menu depend on one attribute.
  var wrap = document.querySelector('[data-asc-currency]') || document.querySelector('.asc-currency-wrap');
  if (!wrap) return;
  var toggle = wrap.querySelector('[data-asc-currency-toggle]');
  var menu = wrap.querySelector('[data-asc-currency-menu]');
  if (!toggle || !menu) return;

  function open() { menu.hidden = false; toggle.setAttribute('aria-expanded', 'true'); }
  function close() { menu.hidden = true; toggle.setAttribute('aria-expanded', 'false'); }

  toggle.addEventListener('click', function (e) {
    e.preventDefault();
    menu.hidden ? open() : close();
  });
  document.addEventListener('click', function (e) {
    if (!wrap.contains(e.target)) close();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !menu.hidden) { close(); toggle.focus(); }
  });
})();

/* Search panel — open/close plus live predictive results.
   Port of the Hydrogen search overlay. Results come from Shopify's own
   /search/suggest.json (products + query suggestions); no app required.
   While a query is present the left column switches from "Trending now" to
   "Suggestions", mirroring the reference. */
(function () {
  var openBtn = document.querySelector('[data-asc-search-open]');
  var tray = document.querySelector('[data-asc-search-tray]');
  if (!openBtn || !tray) return;

  var closeBtn = tray.querySelector('[data-asc-search-close]');
  var input = tray.querySelector('[data-asc-search-input]');
  var form = tray.querySelector('form');
  var chipsWrap = tray.querySelector('[data-asc-search-chips]');
  var sideLabel = tray.querySelector('[data-asc-search-sidelabel]');
  var resLabel = tray.querySelector('[data-asc-search-reslabel]');
  var seeAll = tray.querySelector('[data-asc-search-seeall]');
  var empty = tray.querySelector('[data-asc-search-empty]');
  var results = tray.querySelector('[data-asc-search-results]');

  // Trending chips are the resting state; restored whenever the field is cleared.
  var trendingHTML = chipsWrap ? chipsWrap.innerHTML : '';
  var timer = null;
  var seq = 0;

  function open() {
    tray.classList.add('open');
    tray.setAttribute('aria-hidden', 'false');
    if (input) setTimeout(function () { input.focus(); }, 60);
  }
  function close() {
    tray.classList.remove('open');
    tray.setAttribute('aria-hidden', 'true');
  }

  openBtn.addEventListener('click', function (e) {
    e.preventDefault();
    tray.classList.contains('open') ? close() : open();
  });
  if (closeBtn) closeBtn.addEventListener('click', close);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && tray.classList.contains('open')) close();
  });

  if (!input || !results) return;

  function esc(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // suggest.json returns price as a plain string in currency units.
  function money(v) {
    var n = parseFloat(String(v == null ? '' : v).replace(/[^0-9.]/g, ''));
    if (!isFinite(n)) return '';
    return '₹' + Math.round(n).toLocaleString('en-IN');
  }

  function reset() {
    if (chipsWrap) chipsWrap.innerHTML = trendingHTML;
    if (sideLabel) sideLabel.textContent = 'Trending now';
    if (resLabel) resLabel.textContent = 'Results';
    if (seeAll) seeAll.hidden = true;
    results.hidden = true;
    results.innerHTML = '';
    if (empty) { empty.hidden = false; empty.textContent = 'Start typing to see products'; }
  }

  function render(q, products, queries) {
    if (resLabel) resLabel.textContent = 'Results · "' + q + '"';

    if (chipsWrap) {
      if (queries && queries.length) {
        if (sideLabel) sideLabel.textContent = 'Suggestions';
        chipsWrap.innerHTML = queries.slice(0, 6).map(function (s) {
          return '<button type="button" class="asc-search-chip" data-asc-search-chip>' + esc(s.text) + '</button>';
        }).join('');
      } else {
        if (sideLabel) sideLabel.textContent = 'Trending now';
        chipsWrap.innerHTML = trendingHTML;
      }
    }

    if (!products || !products.length) {
      results.hidden = true;
      results.innerHTML = '';
      if (seeAll) seeAll.hidden = true;
      if (empty) { empty.hidden = false; empty.textContent = 'No products matched “' + q + '”'; }
      return;
    }

    results.innerHTML = products.slice(0, 6).map(function (p) {
      var img = p.featured_image && p.featured_image.url ? p.featured_image.url : '';
      return '<a class="asc-search-hit" href="' + esc(p.url) + '">' +
        '<span class="ph">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="240" height="300">' : '') + '</span>' +
        '<span class="t">' + esc(p.title) + '</span>' +
        '<span class="pr tabular">' + money(p.price) + '</span>' +
      '</a>';
    }).join('');
    results.hidden = false;
    if (empty) empty.hidden = true;
    if (seeAll) seeAll.hidden = false;
  }

  function search(q) {
    var mine = ++seq;
    var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product,query&resources[limit]=6' +
      '&resources[options][unavailable_products]=last';
    fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (mine !== seq) return; // a newer keystroke already won
        var res = d && d.resources && d.resources.results;
        render(q, (res && res.products) || [], (res && res.queries) || []);
      })
      .catch(function () {
        if (mine !== seq) return;
        // Network failure must not strand the panel — the form still submits.
        if (empty) { empty.hidden = false; empty.textContent = 'Press Enter to search for “' + q + '”'; }
        results.hidden = true;
      });
  }

  input.addEventListener('input', function () {
    var q = input.value.trim();
    clearTimeout(timer);
    if (!q) { seq++; reset(); return; }
    timer = setTimeout(function () { search(q); }, 220);
  });

  // Chips (trending and suggestions) run the search straight away.
  if (chipsWrap) {
    chipsWrap.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-asc-search-chip]');
      if (!chip) return;
      input.value = chip.textContent.trim();
      input.focus();
      clearTimeout(timer);
      search(input.value);
    });
  }

  if (seeAll && form) seeAll.addEventListener('click', function () { form.submit(); });
})();
